import Link from "next/link";
import Image from "next/image";
import React, { useState } from "react";
import { mwImage } from "../../../lib/common";
import {
    getLegacyBlogCategoryRedirectDestination,
    getLegacyBlogPostRedirectDestination,
} from "../../../lib/legacyBlogRedirects";
import { NoData } from "../icons";

function searchResultPostHref(parentSlug: string, slug: string) {
    if (parentSlug === "blog") {
        const canonical = getLegacyBlogPostRedirectDestination(slug);
        if (canonical) return canonical;
    }
    return `/${parentSlug}/${slug}/`;
}

function searchResultCategoryHref(slug: string) {
    const canonical = getLegacyBlogCategoryRedirectDestination(slug);
    if (canonical) return canonical;
    return `/blog/category/${slug}/`;
}

const SearchBlog = (props) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [searchClass, setSearchClass] = useState("disable");
    const [searchResults, setSearchResults] = useState([]);
    let parentSlug = props.parentSlug;

    if (parentSlug == undefined) {
        parentSlug = 'blog'
    }

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchTerm(query);

        if (query === "") {
            setSearchResults([]);
            setSearchClass("disable");
        } else {
            setSearchClass("active");
            const results = props.searchInputPostDetails
                .flatMap(itemSearch => itemSearch) // Flatten the array if necessary
                .filter(post =>
                    post.node.title.toLowerCase().includes(query.toLowerCase())
                );
            setSearchResults(results);
        }
    };

    return (
        <div className={"post-search"}>
            <input
                type={'search'}
                placeholder={'Search by name, tag, label or annotation'}
                value={searchTerm}
                className={'blog-search-bar'}
                onChange={handleSearch}
            />
            <div className="svg-icon-search">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.42118 10.3546C3.69273 10.9935 4.08747 11.5728 4.58287 12.0592C5.07827 12.5456 5.66462 12.9296 6.30844 13.1894C6.95227 13.4492 7.64096 13.5797 8.3352 13.5733C9.02944 13.5669 9.71562 13.4239 10.3546 13.1524C10.9935 12.8808 11.5728 12.4861 12.0592 11.9907C12.5456 11.4953 12.9296 10.9089 13.1894 10.2651C13.4492 9.62126 13.5797 8.93256 13.5733 8.23832C13.5669 7.54409 13.4239 6.8579 13.1523 6.21894C12.8808 5.57998 12.486 5.00077 11.9906 4.51436C11.4952 4.02796 10.9089 3.6439 10.2651 3.3841C9.62124 3.1243 8.93255 2.99386 8.23831 3.00022C7.54407 3.00658 6.85789 3.14962 6.21893 3.42117C5.57997 3.69272 5.00076 4.08747 4.51435 4.58287C4.02795 5.07827 3.64389 5.66462 3.38409 6.30844C3.1243 6.95227 2.99386 7.64096 3.00022 8.3352C3.00659 9.02944 3.14963 9.71563 3.42118 10.3546Z" stroke="#343F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.0244 12.0254L16.1247 16.1262" stroke="#343F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <div className={`search-result ${searchClass}`}>
                <div className={"d-flex"}>
                    {searchResults.length > 0 ? (
                        searchResults.map((post, index) => (
                            <div key={index} className={"blocks"}>
                                <div className={"d-flex"}>
                                    <div className={"left-card"}>
                                        {post.node.featuredImage && (
                                            <Link href={searchResultPostHref(parentSlug, post.node.slug)} itemProp="url">
                                                <Image
                                                    src={mwImage(post.node.featuredImage.node.sourceUrl)}
                                                    alt={post.node.title}
                                                    width={200}
                                                    height={200}
                                                    loading="lazy"
                                                    unoptimized
                                                />
                                            </Link>
                                        )}
                                    </div>
                                    <div className={"right-card"}>
                                        {post?.node?.categories?.nodes?.map((searchCategorie, index) => (
                                            <Link key={index} href={searchResultCategoryHref(searchCategorie.slug)} itemProp="url">
                                                <div className={`category ${searchCategorie.slug}`}>
                                                    {searchCategorie.name}
                                                </div>
                                            </Link>
                                        ))}
                                        <Link href={searchResultPostHref(parentSlug, post.node.slug)} itemProp="url">
                                            <h4>{post.node.title}</h4>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="no-results">
                            <NoData />
                            <p> Oops! It’s empty like space. <br />
                                No data available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SearchBlog;
